import React from "react";
import LATimes from "../assets/LATimes.png";
import BeverlyPress from "../assets/BeverlyPress.png";
import SDBJ from "../assets/SDBJ.png";

export default function FeaturedBy() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(209,211,212, 0.2)",
        width:"100%"
      }}
    >
      <h1
        style={{ fontFamily: "Quicksand", fontWeight: "700", color: "#77787b" }}
      >
        Proudly featured by:{" "}
      </h1>

      <img
        src={LATimes}
        style={{ width: "180px", marginTop: "0px", filter: "grayscale(100%)", margin: "0% 5% 0% 5%" }}
      />
      <img
        src={BeverlyPress}
        style={{ width: "180px", filter: "grayscale(100%)" , margin: "0% 5% 0% 5%" }}
      />
      <img src={SDBJ} style={{ width: "180px", filter: "grayscale(100%)", margin: "0% 5% 0% 5%"  }} />
    </div>
  );
}
